import {
  LitElement,
  css,
  html,
  ref,
  createRef
} from 'https://cdn.jsdelivr.net/gh/lit/dist@2/all/lit-all.min.js'

import { StorefrontClient } from 'lib-utils'
class ASContentDirectory extends LitElement {
  static properties = {
    items: {
      type: Array,
      state: true
    },
    currentTypeFilters: {
      type: Array
    },
    currentRegionFilters: {
      type: Array
    },
    groupByRegion: {
      type: Boolean,
      state: true
    },
    totalResultsCount: {
      type: Number
    }, 
    innerWidth: {
      type: Number,
      state: true
    }
  }

  _handleResize = () => {
    this.innerWidth = window.innerWidth
  }

  constructor() {
    super()
    this.currentTypeFilters = []
    this.currentRegionFilters = []
    this.groupByRegion = false
    this.client = new StorefrontClient()

    window.addEventListener('resize', this._handleResize)
  }

  $filtersDrawer = createRef()

  async connectedCallback() {
    super.connectedCallback()

    this.items = await this.client.getMetaObjects('community_member')

    this.viewportWidth > 900 ? this._toggleFilterOnLoad() : this._initialMobileFilterLoad()
    
  }

  get viewportWidth() {
    return window.innerWidth || document.documentElement.clientWidth;
  }

  get typeValues() {
    if (!this.items) return null
    
    return this._sortAndFormatArray([...new Set(this.items.map(item => item.type))])
  }

  get RegionValues() {
    if (!this.items) return null
    return this._sortAndFormatArray([...new Set(this.items.map(item => item.region))])
  }

  t(key) {
    return window.AS_GLOBAL.strings[key] || key;
  }

  _sortAndFormatArray = (array) => {
    return array?.map(item => item.replace(/_/g, ' ')).sort()
  }

  _handleOpenDrawer = () => {
    this.$filtersDrawer.value.show()
  }

  _handleCloseDrawer = () => {
    this.$filtersDrawer.value.hide()
  }

  _handleMobileFiltering = (e) => {
    e.preventDefault()

    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete("type");
    newUrl.searchParams.delete("Region");
    window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());

    const checkboxes = e.target.querySelectorAll('input[type="checkbox"]')
    const selectedTypeFilters = []
    const selectedRegionFilters = []

    checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        let checkboxType = checkbox.dataset.type

        if (checkboxType === "type") {
          selectedTypeFilters.push(checkbox.value)

        } else {
          selectedRegionFilters.push(checkbox.value)
        }
      }
    })

    this.currentTypeFilters = selectedTypeFilters
    this.currentRegionFilters = selectedRegionFilters

    if (this.currentTypeFilters.length > 0) {
      const value = this.currentTypeFilters.join("+");
      newUrl.searchParams.set("type", value);
    }

    if (this.currentRegionFilters.length > 0) {
      const value = this.currentRegionFilters.join("+");
      newUrl.searchParams.set("Region", value)
    }

    window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
    
    this._handleCloseDrawer()
  }

  _updateTotalResultsCount = (data) => {
    let totalCount = 0

    // Iterate through each object in the array
    data.forEach(item => {
        // Iterate through each "grids" array and count the number of items
        item.grids.forEach(grid => {
            totalCount += grid.items.length
        })
    })

    
    let resultsSpan = this.renderRoot.querySelector('#total-results')
    if (resultsSpan) { resultsSpan.innerText = totalCount }
    this.totalResultsCount = totalCount
  }

  _handleFilterClick = (e) => {
    let filterType = e.target.dataset.type
    let filterValue = e.target.dataset.value
    const newUrl = new URL(window.location.href);
  
   //  If 'all', remove all filters
    if (filterType == 'all') {
      this.currentTypeFilters = []
      this.currentRegionFilters = []
      this.renderRoot?.querySelectorAll('.active').forEach(el => el.classList.remove('active'))

      newUrl.searchParams.delete("type");
      newUrl.searchParams.delete("Region");
      window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());
    } else if (filterType == 'type') {
      this.currentTypeFilters = this._toggleFilter(this.currentTypeFilters, filterValue, e.target, filterType)
    } else if (filterType == 'Region') {
      this.currentRegionFilters = this._toggleFilter(this.currentRegionFilters, filterValue, e.target, filterType)
    }
  }

  _toggleFilterOnLoad = () => {
    const newUrl = new URL(window.location.href);

    if (newUrl.searchParams.size > 0) {
      const region = newUrl.searchParams.get("Region")
      const type = newUrl.searchParams.get("type")
      if (region != null) {
        let regionFilterArray = region.split("+")
        this.currentRegionFilters = regionFilterArray
      }

      if (type != null) {
        let typeFilterArray = type.split("+")
        this.currentTypeFilters = typeFilterArray
      }
    }

    setTimeout(() => {
      if (this.currentRegionFilters.length > 0) {
        this.currentRegionFilters.forEach((region) => {
          this.renderRoot?.querySelector(`sl-button[data-type="Region"][data-value="${region}"]`).classList.add('active')
        })
      }

      if (this.currentTypeFilters.length > 0) {
        this.currentTypeFilters.forEach((type) => {
          this.renderRoot?.querySelector(`sl-button[data-type="type"][data-value="${type}"]`).classList.add('active')
        })
      }
    }, 100);
  }

  _toggleFilter = (originalFilterArray, filterValue, targetElement, filterType) => {
    const newUrl = new URL(window.location.href)
    let newFilterArray

    if (originalFilterArray.includes(filterValue)) {
      newFilterArray = originalFilterArray.filter(item => item !== filterValue)
      targetElement.classList.remove('active') 
    } else {
      newFilterArray = Array.from(new Set([...originalFilterArray, filterValue]))
      targetElement.classList.add('active')
    }

    if (newFilterArray.length > 0) {
      const value = newFilterArray.join("+");
      newUrl.searchParams.set(filterType, value);
    } else {
      newUrl.searchParams.delete(filterType);
    }

    window.history.replaceState({ path: newUrl.toString() }, "", newUrl.toString());

    return newFilterArray
  }

  _initialMobileFilterLoad() {
    setTimeout(() => {
      const newUrl = new URL(window.location.href);

      if (newUrl.searchParams.size > 0) {
        const region = newUrl.searchParams.get("Region")
        const type = newUrl.searchParams.get("type")
        if (region != null) {
          let regionFilterArray = region.split("+")
          this.currentRegionFilters = regionFilterArray
        }
  
        if (type != null) {
          let typeFilterArray = type.split("+")
          this.currentTypeFilters = typeFilterArray
        }
      }
    
      const checkboxes = this.renderRoot.querySelectorAll('input[type="checkbox"]')

      checkboxes.forEach(checkbox => {
        let checkboxType = checkbox.dataset.type
        
        if (checkboxType === "type") {
          if (this.currentTypeFilters.includes(checkbox.value)) checkbox.checked = true
        } else {
          if (this.currentRegionFilters.includes(checkbox.value)) checkbox.checked = true
        }
      })
    }, 100);
  }

  processContentItems() {
    this.groupByRegion = this.currentRegionFilters.length || this.currentTypeFilters.length

    // if type filter is applied, types will include only the selected values
    const types = this.currentTypeFilters.length === 0 ? this.typeValues : this.currentTypeFilters

    // separates items acording to type, sort alphabetically, and process item information
    // returns object of items for each type
    const itemsByTypeArray = types.map(type => {
      const processedItems = this.items
        .filter(item => item.type.replace(/_/g, ' ') === type)
        .sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        .map(item => {
          return {
            title: item.name,
            p1: item.location,
            p2: item.restaurant_farm_name,
            region: item.region
          }
      })

      return {
        type: type,
        items: processedItems, //array
      }
    })

    if (!this.groupByRegion) {
      return itemsByTypeArray
    }

    // if Region filter is applied, region will include only the selected values
    const region = this.currentRegionFilters.length === 0 ? this.RegionValues : this.currentRegionFilters
    
    // processedItemsByRegion is the resulting array that will render the grids. Should look like:
    // [
    //   {
    //     filterName: "National",
    //     items: itemByTypeArray
    //   },
    //   {...}
    // ]
    let processedItemsByRegion = []

    // for each Region filter, filter itemsByTypeArray to leave only items with right Region
    region.forEach(region => {
      processedItemsByRegion.push({
        filterName: region,
        grids: itemsByTypeArray.map(({type, items}) => ({
          type,
          items: items.filter(item => item.region === region)
        }))
        .filter(({ items }) => items.length > 0)
      })
    })

    this._updateTotalResultsCount(processedItemsByRegion)
    return processedItemsByRegion
  }

  _renderIcon(type) {
    switch(type) {
      case 'vegetable grower':
        return html `
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="36" viewBox="0 0 22 36" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4824 0.623047C10.3234 0.623047 10.1736 0.625003 10.0435 0.636098C9.9176 0.646837 9.76683 0.669059 9.62732 0.731736C9.46788 0.803369 9.35054 0.915153 9.28379 1.05807C9.22536 1.18318 9.21436 1.31421 9.21436 1.42391C9.21436 1.86981 9.18157 2.56579 9.08516 3.17174C8.98536 3.79909 8.93007 4.05436 8.57251 4.38273C8.31764 4.61679 8.11795 4.85058 7.98348 5.05977C7.9175 5.1624 7.86276 5.26601 7.82633 5.36612C6.75661 5.71792 5.69284 6.31918 5.15311 7.31947C3.96371 9.52375 3.96676 11.1723 3.97415 15.1705C3.97476 15.5008 3.9754 15.8472 3.9754 16.2112C3.9754 19.1342 3.234 20.2239 2.29454 21.6046C1.89924 22.1856 1.46888 22.8181 1.04392 23.6604C-0.0482006 25.8252 -0.890078 29.6991 1.77343 32.5909C2.95333 33.872 4.79015 34.5599 6.53804 34.9319C8.25877 35.298 9.95794 35.3717 11.0171 35.3745V35.378C12.0869 35.378 13.7972 35.3091 15.5261 34.9348C17.2477 34.5621 19.0485 33.8733 20.2266 32.5943C22.8901 29.7025 22.0482 25.8285 20.9561 23.6638C20.5311 22.8215 20.1008 22.1889 19.7055 21.608C18.766 20.2272 18.0246 19.1376 18.0246 16.2146C18.0246 15.8506 18.0252 15.5043 18.0258 15.1741L18.0258 15.1739C18.0332 11.1756 18.0363 9.52709 16.8469 7.32281C16.3072 6.32253 15.2434 5.72126 14.1737 5.36946C14.1372 5.26936 14.0825 5.16575 14.0165 5.06311C13.882 4.85393 13.6824 4.62013 13.4275 4.38607C13.0699 4.0577 13.0146 3.80243 12.9148 3.17508C12.8184 2.56913 12.7856 1.87315 12.7856 1.42725C12.7856 1.24484 12.716 1.08206 12.5909 0.952329C12.4721 0.829223 12.3224 0.755251 12.1904 0.710378C11.9445 0.626786 11.6778 0.615879 11.5 0.62639H10.4824V1.42725H11.5176H11.537L11.5564 1.42587C11.5947 1.42313 11.6484 1.42276 11.7056 1.42801C11.7637 1.43334 11.8119 1.44326 11.8459 1.45481C11.8478 1.45546 11.8496 1.4561 11.8514 1.45672C11.8527 1.92696 11.8874 2.64425 11.9891 3.28329C12.0895 3.91444 12.1677 4.40282 12.7444 4.93251C12.7864 4.97107 12.826 5.00907 12.8632 5.04633C12.1846 4.9279 11.5475 4.88489 11.0606 4.88678L11.0607 4.88488C10.5609 4.87476 9.87334 4.91445 9.13683 5.04298C9.17401 5.00573 9.21358 4.96772 9.25556 4.92917C9.83234 4.39948 9.91052 3.91109 10.0109 3.27995C10.1142 2.63114 10.1483 1.90168 10.1487 1.432C10.227 1.426 10.3325 1.42391 10.4824 1.42391V0.623047ZM10.9612 5.68443L10.9614 5.68886C11.621 5.6755 12.684 5.76358 13.6895 6.06985C14.6997 6.37758 15.5797 6.88214 15.9989 7.65899C17.0986 9.6972 17.0967 11.16 17.0911 15.2549V15.255C17.0907 15.5598 17.0903 15.8792 17.0903 16.2146C17.0903 19.3631 17.9789 20.673 18.9603 22.1198C19.3413 22.6813 19.7361 23.2634 20.0985 23.9817C21.142 26.05 21.8351 29.5554 19.4932 32.098C18.4983 33.1782 16.9285 33.8052 15.2973 34.1583C13.7076 34.5025 12.1172 34.5742 11.083 34.577V34.5738C10.0678 34.5738 8.41726 34.5066 6.76317 34.1546C5.10007 33.8007 3.49986 33.1729 2.50677 32.0947C0.164906 29.5521 0.858004 26.0467 1.90151 23.9783C2.26385 23.2601 2.65874 22.678 3.03966 22.1165C4.0211 20.6697 4.90974 19.3597 4.90974 16.2112C4.90974 15.8758 4.90931 15.5564 4.90889 15.2515C4.90334 11.1566 4.90135 9.69386 6.00114 7.65565C6.42031 6.87879 7.30025 6.37424 8.31049 6.06651C9.27753 5.77194 10.2978 5.67921 10.9612 5.68443ZM8.71003 5.63267C8.71001 5.63268 8.71006 5.63225 8.71023 5.63136C8.71013 5.63222 8.71004 5.63266 8.71003 5.63267ZM13.2898 5.6347C13.2899 5.63558 13.29 5.63601 13.29 5.63601C13.29 5.63601 13.2899 5.63584 13.2899 5.63549C13.2898 5.63528 13.2898 5.63502 13.2898 5.6347Z" fill="#131313"/>
          </svg>
        `    
      case 'grower':
        return html `
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="41" viewBox="0 0 28 41" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.44522 5.86676L12.9408 22.592L14.49 21.9661L7.93444 4.82573L7.92914 4.80067C7.90268 4.67564 7.80428 4.50276 7.60969 4.41045C7.43266 4.32647 7.09929 4.27334 6.49536 4.51734C5.89392 4.76034 5.62915 5.05513 5.51225 5.28893C5.39175 5.52991 5.40598 5.75029 5.44522 5.86676ZM15.2969 21.6401L16.3245 21.2249L16.4738 21.5498C16.7426 22.1349 16.7834 22.2818 17.1269 23.3663L21.0697 21.7733L23.6046 28.0473C24.2109 29.5481 23.8262 31.5907 23.0519 33.3306C22.6611 34.209 22.1609 35.034 21.6093 35.7026C21.0648 36.3628 20.4385 36.9088 19.7832 37.1736C19.0605 37.4656 18.188 37.5154 17.3051 37.4129C16.4147 37.3095 15.4725 37.0467 14.5844 36.672C12.8258 35.9301 11.1843 34.7075 10.614 33.2959L8.07914 27.0219L11.8593 25.4946C11.4244 24.6355 11.3596 24.5714 11.0333 23.7639L10.894 23.419L12.1337 22.9182L4.6369 6.19025L4.63326 6.18024C4.53486 5.90944 4.51663 5.4875 4.73877 5.04323C4.96751 4.58575 5.4303 4.14529 6.21667 3.82758C7.00056 3.51087 7.6206 3.51383 8.07155 3.72776C8.49105 3.92676 8.69576 4.27684 8.76248 4.55437L15.2969 21.6401ZM12.2069 26.1565L9.16469 27.3856L11.4209 32.9699C11.8956 34.1449 13.3368 35.2673 15.015 35.9753C15.8451 36.3255 16.7098 36.5638 17.5043 36.6561C18.3062 36.7491 18.9966 36.689 19.5045 36.4838C19.9384 36.3085 20.4408 35.9021 20.9417 35.2949C21.4355 34.6962 21.8975 33.939 22.263 33.1176C23.0015 31.4581 23.3061 29.6316 22.7977 28.3733L20.5415 22.7891L17.3424 24.0816C17.6865 25.3075 17.2624 25.0241 17.3068 26.139C17.3309 26.7444 17.3007 27.3041 17.1919 27.7503C17.1375 27.9732 17.0592 28.1866 16.9434 28.3688C16.8268 28.5524 16.6557 28.7286 16.4111 28.8274C15.9575 29.0107 15.4834 28.8585 15.108 28.6576C14.7051 28.4419 14.2753 28.0954 13.8486 27.6685C13.0563 26.8762 12.8834 27.3831 12.2069 26.1565ZM11.9816 23.782C12.3189 24.5892 12.3896 24.6394 12.8253 25.4719C13.5033 26.7676 13.7098 26.3245 14.512 27.1269C14.9148 27.5297 15.2887 27.8234 15.6031 27.9916C15.945 28.1746 16.1019 28.15 16.1324 28.1377C16.1324 28.1377 16.1396 28.1348 16.1524 28.1233C16.1664 28.1107 16.1873 28.0878 16.212 28.0489C16.263 27.9685 16.3154 27.8439 16.3585 27.667C16.4447 27.3135 16.4767 26.8266 16.4537 26.2486C16.4079 25.0979 16.8041 25.2919 16.4199 24.0222C16.109 22.9947 16.0935 22.8706 15.8225 22.2301L11.9816 23.782ZM21.657 29.817C21.887 29.8407 22.0313 30.0296 21.9795 30.239C21.749 31.1696 21.471 32.2743 21.049 33.2267C20.6357 34.1594 20.0332 35.0667 19.0747 35.4539C18.0249 35.8781 16.9666 35.6642 16.0209 35.2706C15.2127 34.9343 14.4109 34.4333 13.6794 33.9763C13.5532 33.8975 13.4292 33.82 13.3076 33.7448C13.1239 33.6314 13.0948 33.3955 13.2426 33.218C13.3903 33.0405 13.659 32.9885 13.8427 33.102C13.971 33.1812 14.0996 33.2615 14.2283 33.3418C14.9633 33.8006 15.7039 34.2628 16.448 34.5724C17.3243 34.9371 18.102 35.0446 18.796 34.7642C19.3813 34.5277 19.8608 33.9146 20.2595 33.0149C20.6495 32.1348 20.9135 31.0948 21.1468 30.1531C21.1986 29.9438 21.427 29.7933 21.657 29.817Z" fill="#666666"/>
          </svg>
        `    
      case 'chef':
        return html `
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="19" viewBox="0 0 36 19" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M31.6939 1.63086C29.9971 2.44752 28.2463 3.54951 27.5025 4.20925C25.6168 5.88165 24.4919 6.76706 23.6643 7.31764C24.8257 7.79382 25.7743 8.36219 26.4196 9.00664C26.4865 8.90816 26.5684 8.79088 26.6652 8.6542C26.8558 8.38507 27.1087 8.03429 27.4265 7.59336C27.5734 7.38954 27.7342 7.16646 27.9092 6.92328C29.8284 4.25559 32.8874 2.66798 34.2004 2.10931C34.8487 1.83347 35.1929 1.54686 35.3221 1.31202C35.3819 1.20337 35.3934 1.11095 35.3769 1.02747C35.3596 0.93989 35.3053 0.832429 35.1822 0.710275C35.1401 0.668395 35.04 0.617803 34.8244 0.612257C34.6146 0.606861 34.341 0.645731 34.0121 0.729187C33.3561 0.895613 32.5404 1.22343 31.6939 1.63086ZM26.8358 9.49103C26.8423 9.48094 26.8492 9.47031 26.8566 9.45913C26.9276 9.35072 27.0308 9.2017 27.1693 9.00607C27.3584 8.73904 27.6089 8.39153 27.9257 7.95206C28.0728 7.74789 28.2343 7.52387 28.4106 7.27885C30.2324 4.74652 33.1681 3.21412 34.4431 2.67161C35.1294 2.3796 35.6325 2.02385 35.8628 1.60536C35.9828 1.38734 36.0292 1.15035 35.9816 0.909618C35.9348 0.672979 35.803 0.46142 35.618 0.27769C35.4137 0.0748638 35.124 0.00799258 34.8403 0.000694908C34.5508 -0.00675352 34.2155 0.0461521 33.8595 0.136467C33.1456 0.317584 32.2875 0.665296 31.4251 1.08037C29.7039 1.90875 27.8962 3.03974 27.092 3.75301C24.8974 5.69936 23.7661 6.54924 22.9505 7.0459C20.5162 6.18543 17.2543 5.66349 13.6794 5.66349C9.95963 5.66349 6.57822 6.22862 4.11556 7.15253C2.88533 7.61408 1.86843 8.17107 1.15361 8.80511C0.439011 9.43896 0 10.1753 0 10.9859C0 14.0035 4.01251 19 13.6794 19C18.5283 19 21.939 17.7232 24.1452 16.0827C26.3398 14.451 27.3588 12.4424 27.3588 10.9859C27.3588 10.4538 27.1689 9.95179 26.8358 9.49103ZM25.8609 13.4486C25.3827 14.1665 24.6976 14.9077 23.7759 15.5931C21.6934 17.1415 18.4184 18.3882 13.6794 18.3882C6.74194 18.3882 2.97399 15.7913 1.44343 13.4068C2.13284 13.942 3.04314 14.4169 4.11556 14.8192C6.57822 15.7431 9.95963 16.3082 13.6794 16.3082C17.3992 16.3082 20.7806 15.7431 23.2433 14.8192C24.2876 14.4274 25.1783 13.9668 25.8609 13.4486ZM0.61619 10.9859C0.61619 11.5605 0.925497 12.1439 1.56415 12.7104C2.20258 13.2767 3.14387 13.8007 4.33337 14.2469C6.71017 15.1386 10.0144 15.6965 13.6794 15.6965C17.3444 15.6965 20.6487 15.1386 23.0255 14.2469C24.215 13.8007 25.1562 13.2767 25.7947 12.7104C26.4333 12.1439 26.7426 11.5605 26.7426 10.9859C26.7426 10.5607 26.5744 10.1335 26.2294 9.70998C25.6122 8.95234 24.4589 8.24512 22.8779 7.67032C20.5125 6.81033 17.2688 6.27526 13.6794 6.27526C10.0144 6.27526 6.71017 6.83311 4.33337 7.72481C3.14387 8.17107 2.20258 8.69504 1.56415 9.26133C0.925497 9.82781 0.61619 10.4112 0.61619 10.9859ZM14.9734 9.82351C10.4625 9.82351 6.86918 10.4528 5.65298 10.7622C5.48815 10.8041 5.32029 10.7054 5.27806 10.5418C5.23583 10.3781 5.33522 10.2115 5.50005 10.1696C6.76915 9.84674 10.414 9.21174 14.9734 9.21174C19.5439 9.21174 22.5199 10.1967 23.4716 10.718C23.6206 10.7996 23.6747 10.9857 23.5925 11.1336C23.5103 11.2815 23.3229 11.3353 23.174 11.2537C22.3387 10.7962 19.4732 9.82351 14.9734 9.82351Z" fill="#666666"/>
          </svg>
        `
    }
  }

  _renderItems() {
    return html`
      <div class="content-wrapper">
        ${this.processContentItems().map((contentObject) => {
          if (this.totalResultsCount === 0) { return html`<span class="no-results-message">${this.t("noResultsMessage")}</span>` } 

          if (this.groupByRegion) {
            if (contentObject.grids.length === 0 ) return 
           
            return html`
              <as-content-list-of-grids 
                filterName="${contentObject.filterName}" 
                .items=${contentObject.grids}
                hideFilterName="${this.currentTypeFilters.length === 1}">
              </as-content-list-of-grids>
            `
          } else {
            return html`<as-content-card-grid label=${contentObject.type} .items=${contentObject.items} />`
          }
        })}
      </div>`
  }

  _renderFilterName(filter) {
    switch (filter) {
      case 'chef':
        return this.t("chefFiletLabel")
      case 'grower':
        return this.t("growerFilterLabel")
      case 'vegetable grower':
        return this.t("vegetableGrowerFilterLabel")

    }
  }

  _renderFilters(screensize) {
    let typeFilters = this.typeValues
    let regionFilters = this.RegionValues
    let htmlContent

    if (screensize === 'mobile') {
      return html`
        <sl-drawer label="Filter" class="filters-drawer" ${ref(this.$filtersDrawer)}>
          <form @submit=${this._handleMobileFiltering} class="filters-selection">
            <div>
              <sl-details summary="Region">                    
                ${regionFilters && regionFilters.map((filter) => html `<span><input type="checkbox" name="${filter}" value="${filter}" data-type="Region">${filter}</input></span>`)}
              </sl-details>
          
              <sl-details summary="Type">
                ${typeFilters && typeFilters.map((filter) => html `<span><input type="checkbox" name="${filter}" value="${filter}" data-type="type">${this._renderFilterName(filter)}</input></span>`)}
              </sl-details>
            </div>

            <sl-button type="submit" class="button" slot="footer" variant="primary">${this.t('viewResults')}</sl-button>
          </form>
        </sl-drawer>
      
        <div class="container__header">
          <p><span id="total-results">${this.items?.length} </span>${this.t('resultsLabel')}</p>
          <sl-button variant="text" @click=${this._handleOpenDrawer}>${this.t('filterButtonLabel')}</sl-button>
        </div>
      `
    }

    return html`
      <div class="filters__button-group">
        <sl-button @click=${this._handleFilterClick} variant="text" data-type="all" data-value="all">${this.t('allFilterLabel')}</sl-button>
        ${typeFilters && typeFilters.map((filter) => html`
          <sl-button @click=${this._handleFilterClick} variant="text" data-type="type" data-value="${filter}">
            ${this._renderIcon(filter)}
            ${this._renderFilterName(filter)}
          </sl-button>
        `)}
      </div>
    
      <aside>
        <ul>
          ${regionFilters && regionFilters.map((filter) => html `
            <li><sl-button @click=${this._handleFilterClick} variant="text" data-type="Region" data-value="${filter}">${filter}</sl-button></li>
          `)}
        </ul>
      </aside>
    `
  }

  render() {
    return html`
      ${this.viewportWidth > 900 ? this._renderFilters('desktop') : this._renderFilters('mobile')}
      ${this.items ? this._renderItems() : ''}
    `
  }

  static styles = css `
    .filters-drawer {
      --size: 85%;
      --header-spacing: 17px 15px;
      --body-spacing: 0 16px;
      --footer-spacing: 16px;
    }

    .filters-drawer::part(base) {
      z-index: 1001;
    }

    .filters-drawer::part(panel) {
      background-color: #fff;
    }

    .filters-drawer::part(overlay) {
      opacity: 0.4;
      background: #131313;
    }

    .filters-drawer::part(header) {
      border-bottom: 1px solid #B8B8B8;
    }

    .filters-drawer::part(footer) {
      width: 100%;
      text-align: center;
    }

    .filters-drawer::part(close-button__base) sl-icon::part(svg) {
      height: 20px;
      width: 20px;
    }

    form {
      display: flex;
      flex-direction: column;
      height: 100%;
      justify-content: space-between;
    }

    form sl-button {
      margin-bottom: 17px;
      align-self: center;
    }

    .container__header,
    .filters__button-group {
      display: flex;
      justify-content: space-between;
      border-top: 1px solid #B8B8B8;
      border-bottom: 1px solid #B8B8B8;
      color: #666;
    }

    .container__header p {
      flex: 1;
      margin: 0;
      border-right: 1px solid #B8B8B8;
    }

    .container__header > * {
      padding: 16px 24px;
    }

    .filters__button-group {
      justify-content: center;
      grid-area: header;
    }

    .filters__button-group > * {
      padding: 16px 60px;
      display: flex;
    }

    .filters__button-group sl-button {
      border-left: 1px solid #B8B8B8;
    }

    .filters__button-group sl-button:last-child {
      border-right: 1px solid #B8B8B8;
    }

    .filters__button-group sl-button::part(label) {
      align-items: center;
      display: flex;
      gap: 10px;
    }

    sl-button::part(base) {
      color: #666;
    }

    sl-button.active::part(base) {
      font-weight: 600;
    }

    .container__header,
    sl-button::part(base),
    .filters-drawer::part(header),
    sl-details {
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      letter-spacing: 1px;
      text-transform: uppercase;
    }

    sl-details {
      border-bottom: 1px solid #B8B8B8;
      padding: 10px 0;
      margin-top: 10px;
    }

    sl-details::part(content) {
      display: flex;
      flex-direction: column;
    }

    sl-details span {
      margin: 10px 0;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 10px;
    }

    sl-details span input {
      margin: 0;
      width: 16px;
      height: 16px;
      border-radius: 1px;
    }

    sl-button[variant="primary"]::part(base) {
      display: flex;
      width: 280px;
      height: 40px;
      min-width: 160px;
      padding: 10px 20px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      flex-shrink: 0;
      border-radius: 4px;
      background: #131313;  
      color: #fff;
      border: 0;
    }

    .content-wrapper {
      margin: 40px 0; 
    }

    .no-results-message {
      margin: 0 20px;
    }

    @media screen and (min-width: 900px) {
      :host {
        display: grid;
        grid-template-columns: 330px auto;
        grid-template-rows: 60px auto;
      }

      .filters__button-group {
        grid-column: 1 / -1;
        grid-row: 1 / span 1;
      }

      aside {
        grid-column: 1 / span 1;
        grid-row: 2 / span 1;
      }

      .content-wrapper {
        grid-column: 2 / span 1;
        grid-row: 2 / span 1;
      }

      aside ul {
        list-style: none;
        margin: 60px;
        padding: 0;
      }

      aside ul li {
        border-bottom: 1px solid #B8B8B8;
        padding: 15px 0;
        margin-bottom: 5px;
      }

      .content-wrapper {
        margin: 60px 0; 
      }
    }

    @media screen and (min-width: 1200px) {
      :host {
        display: grid;
        grid-template-columns: 330px auto;
        grid-template-rows: 60px auto;
      }

      .filters__button-group {
        grid-column: 1 / -1;
        grid-row: 1 / span 1;
      }

      aside {
        grid-column: 1 / span 1;
        grid-row: 2 / span 1;
      }

      .content-wrapper {
        grid-column: 2 / span 1;
        grid-row: 2 / span 1;
      }

      .filters__button-group sl-button:not(:first-child) {
        min-width: 330px;
      }
    }
  `
}

customElements.define('as-content-directory', ASContentDirectory)

class ASContentCard extends LitElement {
  static properties = {
    title: {
      type: String
    },
    p1: {
      type: String
    },
    p2: {
      type: String
    }
  }

  render() {
    return html`
      <h6>${this.title}</h6>
      <p>${this.p1}</p>
      <p>${this.p2}</p>
    `
  }

  static styles = css `
    h6 {
      color: #131313;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 140%;
      letter-spacing: 1px;
      text-transform: uppercase;
      margin: 0;
    }

    p {
      color: #131313;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin: 5px 0;
    }

    @media screen and (min-width: 700px) {
      h6 {
        font-size: 18px;
        line-height: 130%;
      }
    }
  `
}

customElements.define('as-content-card', ASContentCard)

class ASContentCardGrid extends LitElement {
  static properties = {
    label: {
      type: String
    },
    items: {
      type: Array,
    },
    hideFilterName: {
      type: String,
    }
  }

  _renderIcon(type) {
    switch(type) {
      case 'grower':
        return html `
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="41" viewBox="0 0 28 41" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.44522 5.86676L12.9408 22.592L14.49 21.9661L7.93444 4.82573L7.92914 4.80067C7.90268 4.67564 7.80428 4.50276 7.60969 4.41045C7.43266 4.32647 7.09929 4.27334 6.49536 4.51734C5.89392 4.76034 5.62915 5.05513 5.51225 5.28893C5.39175 5.52991 5.40598 5.75029 5.44522 5.86676ZM15.2969 21.6401L16.3245 21.2249L16.4738 21.5498C16.7426 22.1349 16.7834 22.2818 17.1269 23.3663L21.0697 21.7733L23.6046 28.0473C24.2109 29.5481 23.8262 31.5907 23.0519 33.3306C22.6611 34.209 22.1609 35.034 21.6093 35.7026C21.0648 36.3628 20.4385 36.9088 19.7832 37.1736C19.0605 37.4656 18.188 37.5154 17.3051 37.4129C16.4147 37.3095 15.4725 37.0467 14.5844 36.672C12.8258 35.9301 11.1843 34.7075 10.614 33.2959L8.07914 27.0219L11.8593 25.4946C11.4244 24.6355 11.3596 24.5714 11.0333 23.7639L10.894 23.419L12.1337 22.9182L4.6369 6.19025L4.63326 6.18024C4.53486 5.90944 4.51663 5.4875 4.73877 5.04323C4.96751 4.58575 5.4303 4.14529 6.21667 3.82758C7.00056 3.51087 7.6206 3.51383 8.07155 3.72776C8.49105 3.92676 8.69576 4.27684 8.76248 4.55437L15.2969 21.6401ZM12.2069 26.1565L9.16469 27.3856L11.4209 32.9699C11.8956 34.1449 13.3368 35.2673 15.015 35.9753C15.8451 36.3255 16.7098 36.5638 17.5043 36.6561C18.3062 36.7491 18.9966 36.689 19.5045 36.4838C19.9384 36.3085 20.4408 35.9021 20.9417 35.2949C21.4355 34.6962 21.8975 33.939 22.263 33.1176C23.0015 31.4581 23.3061 29.6316 22.7977 28.3733L20.5415 22.7891L17.3424 24.0816C17.6865 25.3075 17.2624 25.0241 17.3068 26.139C17.3309 26.7444 17.3007 27.3041 17.1919 27.7503C17.1375 27.9732 17.0592 28.1866 16.9434 28.3688C16.8268 28.5524 16.6557 28.7286 16.4111 28.8274C15.9575 29.0107 15.4834 28.8585 15.108 28.6576C14.7051 28.4419 14.2753 28.0954 13.8486 27.6685C13.0563 26.8762 12.8834 27.3831 12.2069 26.1565ZM11.9816 23.782C12.3189 24.5892 12.3896 24.6394 12.8253 25.4719C13.5033 26.7676 13.7098 26.3245 14.512 27.1269C14.9148 27.5297 15.2887 27.8234 15.6031 27.9916C15.945 28.1746 16.1019 28.15 16.1324 28.1377C16.1324 28.1377 16.1396 28.1348 16.1524 28.1233C16.1664 28.1107 16.1873 28.0878 16.212 28.0489C16.263 27.9685 16.3154 27.8439 16.3585 27.667C16.4447 27.3135 16.4767 26.8266 16.4537 26.2486C16.4079 25.0979 16.8041 25.2919 16.4199 24.0222C16.109 22.9947 16.0935 22.8706 15.8225 22.2301L11.9816 23.782ZM21.657 29.817C21.887 29.8407 22.0313 30.0296 21.9795 30.239C21.749 31.1696 21.471 32.2743 21.049 33.2267C20.6357 34.1594 20.0332 35.0667 19.0747 35.4539C18.0249 35.8781 16.9666 35.6642 16.0209 35.2706C15.2127 34.9343 14.4109 34.4333 13.6794 33.9763C13.5532 33.8975 13.4292 33.82 13.3076 33.7448C13.1239 33.6314 13.0948 33.3955 13.2426 33.218C13.3903 33.0405 13.659 32.9885 13.8427 33.102C13.971 33.1812 14.0996 33.2615 14.2283 33.3418C14.9633 33.8006 15.7039 34.2628 16.448 34.5724C17.3243 34.9371 18.102 35.0446 18.796 34.7642C19.3813 34.5277 19.8608 33.9146 20.2595 33.0149C20.6495 32.1348 20.9135 31.0948 21.1468 30.1531C21.1986 29.9438 21.427 29.7933 21.657 29.817Z" fill="#666666"/>
          </svg>
        `    
      case 'vegetable grower':
        return html `
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="35" viewBox="0 0 22 35" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4824 0C10.3234 0 10.1736 0.00195582 10.0435 0.013051C9.9176 0.0237901 9.76683 0.0460125 9.62732 0.108689C9.46788 0.180322 9.35054 0.292106 9.28379 0.43502C9.22536 0.560138 9.21436 0.691163 9.21436 0.80086C9.21436 1.24676 9.18157 1.94274 9.08516 2.54869C8.98536 3.17604 8.93007 3.43131 8.57251 3.75968C8.31764 3.99375 8.11795 4.22754 7.98348 4.43672C7.9175 4.53936 7.86276 4.64297 7.82633 4.74307C6.75661 5.09487 5.69284 5.69614 5.15311 6.69642C3.96371 8.9007 3.96676 10.5492 3.97415 14.5475C3.97476 14.8778 3.9754 15.2241 3.9754 15.5882C3.9754 18.5112 3.234 19.6008 2.29454 20.9816C1.89924 21.5626 1.46888 22.1951 1.04392 23.0374C-0.0482006 25.2021 -0.890078 29.0761 1.77343 31.9679C2.95333 33.2489 4.79015 33.9369 6.53804 34.3088C8.25877 34.675 9.95794 34.7486 11.0171 34.7515V34.7549C12.0869 34.7549 13.7972 34.6861 15.5261 34.3118C17.2477 33.939 19.0485 33.2503 20.2266 31.9712C22.8901 29.0794 22.0482 25.2055 20.9561 23.0407C20.5311 22.1984 20.1008 21.5659 19.7055 20.9849C18.766 19.6042 18.0246 18.5145 18.0246 15.5915C18.0246 15.2276 18.0252 14.8813 18.0258 14.551L18.0258 14.5508C18.0332 10.5526 18.0363 8.90404 16.8469 6.69976C16.3072 5.69948 15.2434 5.09821 14.1737 4.74641C14.1372 4.64631 14.0825 4.5427 14.0165 4.44007C13.882 4.23088 13.6824 3.99709 13.4275 3.76303C13.0699 3.43465 13.0146 3.17938 12.9148 2.55204C12.8184 1.94608 12.7856 1.25011 12.7856 0.804203C12.7856 0.621789 12.716 0.459008 12.5909 0.329282C12.4721 0.206176 12.3224 0.132204 12.1904 0.0873311C11.9445 0.00373907 11.6778 -0.00716821 11.5 0.00334322H10.4824V0.804203H11.5176H11.537L11.5564 0.80282C11.5947 0.800086 11.6484 0.799713 11.7056 0.804963C11.7637 0.810298 11.8119 0.820216 11.8459 0.831763C11.8478 0.832416 11.8496 0.833054 11.8514 0.833674C11.8527 1.30391 11.8874 2.0212 11.9891 2.66024C12.0895 3.29139 12.1677 3.77977 12.7444 4.30947C12.7864 4.34802 12.826 4.38602 12.8632 4.42328C12.1846 4.30485 11.5475 4.26185 11.0606 4.26373L11.0607 4.26183C10.5609 4.25171 9.87334 4.2914 9.13683 4.41994C9.17401 4.38268 9.21358 4.34468 9.25556 4.30612C9.83234 3.77643 9.91052 3.28805 10.0109 2.6569C10.1142 2.0081 10.1483 1.27863 10.1487 0.808952C10.227 0.802957 10.3325 0.80086 10.4824 0.80086V0ZM10.9612 5.06139L10.9614 5.06581C11.621 5.05245 12.684 5.14053 13.6895 5.44681C14.6997 5.75453 15.5797 6.25909 15.9989 7.03595C17.0986 9.07415 17.0967 10.5369 17.0911 14.6318V14.632C17.0907 14.9368 17.0903 15.2562 17.0903 15.5915C17.0903 18.74 17.9789 20.05 18.9603 21.4968C19.3413 22.0583 19.7361 22.6404 20.0985 23.3586C21.142 25.427 21.8351 28.9324 19.4932 31.475C18.4983 32.5552 16.9285 33.1821 15.2973 33.5353C13.7076 33.8795 12.1172 33.9511 11.083 33.954V33.9507C10.0678 33.9507 8.41726 33.8836 6.76317 33.5316C5.10007 33.1776 3.49986 32.5499 2.50677 31.4716C0.164906 28.929 0.858004 25.4236 1.90151 23.3553C2.26385 22.637 2.65874 22.0549 3.03966 21.4934C4.0211 20.0466 4.90974 18.7367 4.90974 15.5882C4.90974 15.2528 4.90931 14.9333 4.90889 14.6285C4.90334 10.5336 4.90135 9.07081 6.00114 7.0326C6.42031 6.25575 7.30025 5.75119 8.31049 5.44346C9.27753 5.1489 10.2978 5.05616 10.9612 5.06139ZM8.71003 5.00962C8.71001 5.00963 8.71006 5.0092 8.71023 5.00831C8.71013 5.00917 8.71004 5.00961 8.71003 5.00962ZM13.2898 5.01165C13.2899 5.01253 13.29 5.01296 13.29 5.01297C13.29 5.01297 13.2899 5.01279 13.2899 5.01244C13.2898 5.01224 13.2898 5.01197 13.2898 5.01165Z" fill="#131313"/>
          </svg>
        `    
      case 'chef':
        return html `
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="19" viewBox="0 0 36 19" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M31.6939 1.63086C29.9971 2.44752 28.2463 3.54951 27.5025 4.20925C25.6168 5.88165 24.4919 6.76706 23.6643 7.31764C24.8257 7.79382 25.7743 8.36219 26.4196 9.00664C26.4865 8.90816 26.5684 8.79088 26.6652 8.6542C26.8558 8.38507 27.1087 8.03429 27.4265 7.59336C27.5734 7.38954 27.7342 7.16646 27.9092 6.92328C29.8284 4.25559 32.8874 2.66798 34.2004 2.10931C34.8487 1.83347 35.1929 1.54686 35.3221 1.31202C35.3819 1.20337 35.3934 1.11095 35.3769 1.02747C35.3596 0.93989 35.3053 0.832429 35.1822 0.710275C35.1401 0.668395 35.04 0.617803 34.8244 0.612257C34.6146 0.606861 34.341 0.645731 34.0121 0.729187C33.3561 0.895613 32.5404 1.22343 31.6939 1.63086ZM26.8358 9.49103C26.8423 9.48094 26.8492 9.47031 26.8566 9.45913C26.9276 9.35072 27.0308 9.2017 27.1693 9.00607C27.3584 8.73904 27.6089 8.39153 27.9257 7.95206C28.0728 7.74789 28.2343 7.52387 28.4106 7.27885C30.2324 4.74652 33.1681 3.21412 34.4431 2.67161C35.1294 2.3796 35.6325 2.02385 35.8628 1.60536C35.9828 1.38734 36.0292 1.15035 35.9816 0.909618C35.9348 0.672979 35.803 0.46142 35.618 0.27769C35.4137 0.0748638 35.124 0.00799258 34.8403 0.000694908C34.5508 -0.00675352 34.2155 0.0461521 33.8595 0.136467C33.1456 0.317584 32.2875 0.665296 31.4251 1.08037C29.7039 1.90875 27.8962 3.03974 27.092 3.75301C24.8974 5.69936 23.7661 6.54924 22.9505 7.0459C20.5162 6.18543 17.2543 5.66349 13.6794 5.66349C9.95963 5.66349 6.57822 6.22862 4.11556 7.15253C2.88533 7.61408 1.86843 8.17107 1.15361 8.80511C0.439011 9.43896 0 10.1753 0 10.9859C0 14.0035 4.01251 19 13.6794 19C18.5283 19 21.939 17.7232 24.1452 16.0827C26.3398 14.451 27.3588 12.4424 27.3588 10.9859C27.3588 10.4538 27.1689 9.95179 26.8358 9.49103ZM25.8609 13.4486C25.3827 14.1665 24.6976 14.9077 23.7759 15.5931C21.6934 17.1415 18.4184 18.3882 13.6794 18.3882C6.74194 18.3882 2.97399 15.7913 1.44343 13.4068C2.13284 13.942 3.04314 14.4169 4.11556 14.8192C6.57822 15.7431 9.95963 16.3082 13.6794 16.3082C17.3992 16.3082 20.7806 15.7431 23.2433 14.8192C24.2876 14.4274 25.1783 13.9668 25.8609 13.4486ZM0.61619 10.9859C0.61619 11.5605 0.925497 12.1439 1.56415 12.7104C2.20258 13.2767 3.14387 13.8007 4.33337 14.2469C6.71017 15.1386 10.0144 15.6965 13.6794 15.6965C17.3444 15.6965 20.6487 15.1386 23.0255 14.2469C24.215 13.8007 25.1562 13.2767 25.7947 12.7104C26.4333 12.1439 26.7426 11.5605 26.7426 10.9859C26.7426 10.5607 26.5744 10.1335 26.2294 9.70998C25.6122 8.95234 24.4589 8.24512 22.8779 7.67032C20.5125 6.81033 17.2688 6.27526 13.6794 6.27526C10.0144 6.27526 6.71017 6.83311 4.33337 7.72481C3.14387 8.17107 2.20258 8.69504 1.56415 9.26133C0.925497 9.82781 0.61619 10.4112 0.61619 10.9859ZM14.9734 9.82351C10.4625 9.82351 6.86918 10.4528 5.65298 10.7622C5.48815 10.8041 5.32029 10.7054 5.27806 10.5418C5.23583 10.3781 5.33522 10.2115 5.50005 10.1696C6.76915 9.84674 10.414 9.21174 14.9734 9.21174C19.5439 9.21174 22.5199 10.1967 23.4716 10.718C23.6206 10.7996 23.6747 10.9857 23.5925 11.1336C23.5103 11.2815 23.3229 11.3353 23.174 11.2537C22.3387 10.7962 19.4732 9.82351 14.9734 9.82351Z" fill="#666666"/>
          </svg>
        `
    }
  }

  _renderFilterName(filter) {
    switch (filter) {
      case 'chef':
        return window.AS_GLOBAL.strings["chefFiletLabel"]
      case 'grower':
        return window.AS_GLOBAL.strings["growerFilterLabel"]
      case 'vegetable grower':
        return window.AS_GLOBAL.strings["vegetableGrowerFilterLabel"]

    }
  }

  render() {
    return html`
      <h4 class="${this.hideFilterName == "true" ? 'hide-filter-name' : ''}">
        ${this._renderIcon(this.label)} ${this._renderFilterName(this.label)}
      </h4>
      <div class="grid-container">
      ${this.items && this.items.map((item) => html`
        <as-content-card title="${item.title}" p1="${item.p1}" p2="${item.p2}"></as-content-card>
      `)}
      </div>
    `
  }

  static styles = css `
    :host {
      display: block;
      margin: 40px 0;
      padding: 0 60px;
    }

    .grid-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 40px;
      row-gap: 60px;
    }

    h4 {
      color: #131313;
      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%; 
      text-transform: uppercase;
      margin: 0;
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    h4.hide-filter-name {
      display: none;
    }

    @media screen and (min-width: 1200px) {
      .grid-container {
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: auto;
        row-gap: 45px;
      }
    }
  `
}

customElements.define('as-content-card-grid', ASContentCardGrid)


class ASContentListOfGrids extends LitElement {
  static properties = {
    filterName: {
      type: String
    },
    items: {
      type: Array,
    },
    hideFilterName: {
      type: String
    }
  }
  connectedCallback() {
    super.connectedCallback()
  }

  render() {
    return html`
      <h3>${this.filterName}</h3>

      ${this.items && this.items.map((item) => html`
        <as-content-card-grid 
          label=${item.type} 
          .items=${item.items}
          hideFilterName=${this.hideFilterName} />`
      )}
    `
  }

  static styles = css`
    as-content-list-of-grids > as-content-card-grid:last-child {
      border-bottom: 1px solid #B8B8B8;
    }

    h3 {
      color: #131313;
      font-size: 32px;
      font-style: normal;
      font-weight: 500;
      line-height: 100%; 
      text-transform: uppercase;
      margin: 0 20px;
    }

    @media screen and (min-width: 700px) {
      h3 {
        margin: 0 60px;
      }
    }
  `
}

customElements.define('as-content-list-of-grids', ASContentListOfGrids)